import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../api/v1";
import { ApiResponse } from "../../../../../../types/api-response";
import axios from "../../../../../../utils/axiosInceptor";

export type ApproveCreditNoteRequest = {
  pdcId: string;
  creditNoteId: string;
  approvalStatus: "approved" | "rejected";
};

const approveCreditNoteRequest = async (payload: ApproveCreditNoteRequest) => {
  const url = `${apiV1Endpoint}/booking/approveCreditNote`;

  const response = await axios.post<ApiResponse>(url, payload);
  return response.data.result;
};

type UseApproveCreditNoteOptions = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useApproveCreditNote = (options: UseApproveCreditNoteOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: approveCreditNoteRequest,
    onSuccess,
    onError,
  });

  return {
    approveCreditNoteRequest: mutateAsync,
    isPendingApproveCreditNoteRequest: isPending,
  };
};
